import { useContext } from 'react';
import ActiveMenuContext from './ActiveMenuContext';

const useActiveMenu = () => useContext(ActiveMenuContext);

export default useActiveMenu;
